import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g clip-path=\"url(#clip0_5429_6774)\"><rect x=\"4.5\" y=\"9.5\" width=\"11\" height=\"2\" rx=\"1\" fill=\"white\"></rect><rect x=\"11\" y=\"5\" width=\"11\" height=\"2\" rx=\"1\" transform=\"rotate(90 11 5)\" fill=\"white\"></rect><rect x=\"1\" y=\"1.5\" width=\"18\" height=\"18\" rx=\"2\" stroke=\"white\" stroke-width=\"2\"></rect></g><defs><clipPath id=\"clip0_5429_6774\"><rect width=\"20\" height=\"20\" fill=\"white\" transform=\"translate(0 0.5)\"></rect></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }